import { useTranslation } from 'react-i18next';

import { PLATFORM_PERMISSIONS, PERMISSION_ACTIONS } from '@thinknet-gmbh/platform-common';

import { useCreateCompanyPositions } from 'src/hooks/company-positions/create-company-positions.hook';
import { useGetCompanyPositions } from 'src/hooks/company-positions/get-company-positions.hook';
import { CommonBoxExpand } from 'src/pages/settings/components/company-settings/components/common-box-expand';
import { useUpdateCompanyPositions } from 'src/hooks/company-positions/update-company-positions.hook';
import { useDeleteCompanyPositionById } from 'src/hooks/company-positions/delete-company-position.hook';
import { usePermissionCheck } from 'src/hooks/permission-check.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { USER_POSITION_LABELS } from './user-position.constants';

const UserPosition = () => {
  const { t } = useTranslation('settings');

  const currentCompanyId = useGetCurrentCompanyId();
  const { companyPositions } = useGetCompanyPositions({
    companyId: currentCompanyId,
    deleted: false,
  });
  const createCompanyPositions = useCreateCompanyPositions();
  const updateCompanyPositions = useUpdateCompanyPositions();
  const deleteCompanyPositionById = useDeleteCompanyPositionById();

  const { checkRule } = usePermissionCheck(PLATFORM_PERMISSIONS.companySettings);
  const canEdit = checkRule(PERMISSION_ACTIONS.update);
  const canCreate = checkRule(PERMISSION_ACTIONS.create);
  const canDelete = checkRule(PERMISSION_ACTIONS.delete);

  const onSubmitCreate = (name: any) => {
    createCompanyPositions({
      variables: {
        payload: [
          {
            companyId: currentCompanyId,
            name,
          },
        ],
      },
    });
  };

  const onSubmitDelete = (value: any) => {
    deleteCompanyPositionById({ variables: { companyPositionId: value._id } });
  };

  const onSubmitUpdate = ({ userPositions }: any) => {
    const newCompanyPositions = userPositions.filter((k: any) => !k._id);
    updateCompanyPositions({ variables: { payload: userPositions.filter((k: any) => !!k._id) } });

    if (newCompanyPositions.length) {
      createCompanyPositions({
        variables: {
          payload: newCompanyPositions.map((k: any) => ({ companyId: currentCompanyId, ...k })),
        },
      });
    }
  };

  return (
    <CommonBoxExpand
      data={companyPositions}
      formListName={USER_POSITION_LABELS.userPositions}
      boxExpandTitle={t('companySettings.labels.userPositions')}
      createButtonTxt={t('companySettings.buttons.addNewPosition')}
      formItemName={USER_POSITION_LABELS.positionName}
      formItemLabel={t('companySettings.labels.userPositionName')}
      requiredMessage={t('companySettings.exceptions.requiredUserPosition')}
      inputPlaceholder={t('companySettings.labels.hrManager')}
      onSubmitCreateForm={onSubmitCreate}
      onSubmitEditForm={onSubmitUpdate}
      onSubmitDelete={onSubmitDelete}
      canCreate={canCreate}
      canEdit={canEdit}
      canDelete={canDelete}
    />
  );
};

export default UserPosition;
